import { prepareFilterParams } from './../../../orders/core/_requests';
import axios from 'axios'
import { IDiscountBulkModel, IDiscountSpecialBody } from './_models';
import {API_URL} from '../../../../tenant/apiBase'

export const BULK_SPECIAL_TEMPLATE = `${API_URL}/api/partner-portal/special/bulk-template`
export const REMOVE_BULK_SPECIAL_TEMPLATE = `${API_URL}/api/partner-portal/special/remove-special-bulk-template`
export const ADD_BULK_SELECTION_PRODUCTS = `${API_URL}/api/partner-portal/special/products`
export const GET_SELECTION_APPLY_SPECIAL = `${API_URL}/api/partner-portal/special/special`
export const SET_SELECTION_APPLY_SPECIAL = `${API_URL}/api/partner-portal/special/special`
export const REMOVE_SPECIAL_PENDING_PRODUCT = `${API_URL}/api/partner-portal/special/product`
export const SET_BULK_SPECIAL_SELECTION_FORM = `${API_URL}/api/partner-portal/special/bulk-special`
export const REMOVE_BULK_SPECIAL_SELECTION_FORM = `${API_URL}/api/partner-portal/special/remove-by-bulk-special`
export const SET_CONNECTED_PRODUCTS = `${API_URL}/api/partner-portal/special/connected-products`
export const REMOVE_PENDING_REQUEST = `${API_URL}/api/partner-portal/special/remove-special-requests`
export const REMOVE_DUPLICATE_BARCODE_REQUEST = `${API_URL}/api/partner-portal/product/delete-duplicate-barcodes`


function formatSpecialDateTime(dateTime: string) {
  const date = new Date(dateTime)
  if (dateTime.includes('T')) {
    return date.toISOString()
  }
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}T00:00:00`
}

// Async ADD-discount bulk: the backend (SpecialController@bulkSpecial) now
// queues the sheet and returns {job_id} as JSON instead of streaming the result
// blob. The supplier tracks progress + downloads the result on the Bulk Jobs
// page. If no job_id comes back (e.g. async disabled server-side) the caller
// shows an error.
export async function enqueueBulkSpecial(
  token: string | undefined,
  data: IDiscountBulkModel,
  language: string,
) {
  const formData = new FormData()
  formData.append('file', data.file)
  formData.append('date_start', formatSpecialDateTime(data.date_start))
  formData.append('date_end', formatSpecialDateTime(data.date_end))
  return axios.post<{job_id?: number; status?: string; total_rows?: number; message?: string}>(
    `${SET_BULK_SPECIAL_SELECTION_FORM}`,
    formData,
    {headers: {token: token || '', 'content-type': 'multipart/form-data', language}},
  )
}

// Async REMOVE-discount bulk: backend (SpecialController@removeSpecialByBulk)
// queues + returns {job_id}; tracked on the Bulk Jobs page.
export async function enqueueRemoveSpecialBulk(
  token: string | undefined,
  data: any,
  language: string,
) {
  const formData = new FormData()
  formData.append('file', data.file)
  return axios.post<{job_id?: number; status?: string; total_rows?: number; message?: string}>(
    `${REMOVE_BULK_SPECIAL_SELECTION_FORM}`,
    formData,
    {headers: {token: token || '', 'content-type': 'multipart/form-data', language}},
  )
}


export async function addProductsDiscount(token: string | undefined,language:string, data: IDiscountSpecialBody) {
    const formatDateTime = (dateTime: string) => {
      const date = new Date(dateTime);
      
      if (dateTime.includes('T')) {
        return date.toISOString();
      }
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}T00:00:00`;
    };

    const formattedData = {
      ...data,
      date_start: formatDateTime(data.date_start),
      date_end: formatDateTime(data.date_end)
    };

    return axios.post<any>(`${ADD_BULK_SELECTION_PRODUCTS}`, formattedData, {
      headers: {token: token || '',language,'ACCEPT': 'application/json'},
    })
}

export async function applySpecialPendingProducts(token: string | undefined, data: {special_ids:number[]}) {
  return axios.post<any>(`${SET_SELECTION_APPLY_SPECIAL}`, data, {
    headers: {token: token || ''},
  })
}

export async function applyConnectedProducts(
  token: string | undefined,
  data: {
    special_ids: number[] | string[]
    // Per-row edited quantity / sale price, keyed by supplier_product_special_id.
    edits?: Record<string, {quantity?: string | number; sale_price?: string | number}>
  }
) {
  return axios.post<any>(`${SET_CONNECTED_PRODUCTS}`, data, {
    headers: {token: token || ''},
  })
}

// get special
export async function getApplySpecialProducts(token: string | undefined,language:string, filters?:any) {
    return axios.get<any>(`${GET_SELECTION_APPLY_SPECIAL}?${filters ? prepareFilterParams(filters): ''}`, {
      headers: {token: token || '',language},
    })
}

export async function removePendingSpecialProduct(token: string | undefined, special_id:number |string) {
    return axios.delete<any>(`${REMOVE_SPECIAL_PENDING_PRODUCT}?special_id=${special_id}`, {
      headers: {token: token || ''},
    })
}


// get special
export async function deleteRequest(token: string | undefined,language:string,isProductBulk:boolean = false) {
  let url = REMOVE_PENDING_REQUEST
  if (isProductBulk) url = REMOVE_DUPLICATE_BARCODE_REQUEST
  return axios.delete<any>(`${url}`, {
    headers: {token: token || '',language},
  })
}
